import { Routes, Route } from 'react-router-dom'
import Layout from './components/Layout'
import HomePage from './pages/Home'
import MenuPage from './pages/Menu'
import CateringPage from './pages/Catering'
import CateringMenuPage from './pages/CateringMenu'
import ContactPage from './pages/Contact'

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<HomePage />} />
        <Route path="menu" element={<MenuPage />} />
        <Route path="menu/catering" element={<CateringMenuPage />} />
        <Route path="catering" element={<CateringPage />} />
        <Route path="contact" element={<ContactPage />} />
      </Route>
    </Routes>
  )
}
